import { initReveals } from "./reveal";

// Reads "?to=<id>" from the current router location and either
// smooth-scrolls to that element, or scrolls to top of page.
// Call from componentDidMount on each routed page.
// Also wires up scroll-reveal animations for the freshly mounted DOM.
export function handleLandingScroll(location) {
  if (typeof window === "undefined") return;

  setTimeout(initReveals, 40);

  const search = (location && location.search) || "";
  const params = new URLSearchParams(search);
  const target = params.get("to");

  if (!target) {
    window.scrollTo(0, 0);
    return;
  }

  // wait for the page to render its DOM
  setTimeout(() => {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // fallback: top
      window.scrollTo(0, 0);
    }
  }, 60);
}
